export default "__VITE_ASSET__D1Cgq9Az__"